// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Job page's Activity tab (GRAVY-10877; Figma 38490:69618). Tokens come
   from the \`.dashv2\` scope this tab renders inside, so the colours are the
   dashboard's own rather than a second copy of them. */

.jobact {
  width: 100%;
  padding: 0 24px 24px;
}

/* 16px between entries: Figma's Log frames sit at 0 / 125 / 250 / 371 with
   heights of 109 and 105. */
.jobact-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.jobact-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.jobact-entry.is-automated .jobact-head {
  gap: 8px;
}

/* A person's 28px photo or initials (the dashboard Avatar is 40px). */
.jobact-avatar .dashv2-avatar {
  width: 28px;
  height: 28px;
  font-size: 11px;
}

/* The GravyWork mark at the design's 24px, the artwork scaled with it. Two
   classes so it wins over \`.dashv2-panel-actbot\` whatever order the two
   stylesheets load in. */
.jobact .jobact-mark {
  width: 24px;
  height: 24px;
  background-size: 18px 16.5px;
}

.jobact-who {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.jobact-entry.is-automated .jobact-who {
  gap: 0;
}

.jobact-name {
  font-size: 14px;
  line-height: 1.4;
  color: var(--black);
}
.jobact-name b {
  font-weight: 700;
}
.jobact-role {
  font-weight: 400;
}

.jobact-when {
  font-size: 12px;
  line-height: 1.4;
  color: var(--subtext);
}

/* The sentence, indented under the name: 36px left, 12px right and vertical. */
.jobact-body {
  padding: 12px 12px 12px 36px;
}
.jobact-card {
  padding: 12px;
  border: 1px solid var(--stroke-gray);
  border-radius: 12px;
  background: #fafafa;
  font-size: 14px;
  line-height: 1.4;
  color: var(--black);
}
/* The shared sentence is a flex item in the panel row; here it is just text. */
.jobact-card .dashv2-panel-acttext {
  display: inline;
}

.jobact-occurrence,
.jobact-state {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.4;
  color: var(--subtext);
}

.jobact-retry,
.jobact-more {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-weight: 600;
  color: var(--text-green);
  cursor: pointer;
}
.jobact-more {
  margin: 16px 0 0 36px;
}
.jobact-retry:hover,
.jobact-more:hover {
  text-decoration: underline;
}
.jobact-more:disabled {
  color: var(--subtext);
  cursor: default;
  text-decoration: none;
}

/* The sort toggle, at the right end of the tab strip as Figma places it. */
.jobact-sort {
  position: absolute;
  top: 50%;
  right: 24px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: none;
  color: #1c1c1c;
  cursor: pointer;
}
.jobact-sort:hover {
  background: #f3f3f3;
}
.jobact-sort:focus-visible {
  outline: 2px solid #2f6fed;
  outline-offset: 2px;
}
.jobact-sort svg {
  width: 24px;
  height: 24px;
}

@media (max-width: 600px) {
  .jobact {
    padding: 0 0 24px;
  }
  .jobact-body {
    padding-left: 12px;
    padding-right: 0;
  }
  .jobact-sort {
    right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/Agency/Job/ActivityTab/jobActivity.css"],"names":[],"mappings":"AAAA;;uDAEuD;;AAEvD;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;4BAC4B;AAC5B;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,QAAQ;AACV;;AAEA,sEAAsE;AACtE;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;yBAEyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,MAAM;AACR;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,+EAA+E;AAC/E;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,+EAA+E;AAC/E;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;AACF","sourcesContent":["/* The Job page's Activity tab (GRAVY-10877; Figma 38490:69618). Tokens come\n   from the `.dashv2` scope this tab renders inside, so the colours are the\n   dashboard's own rather than a second copy of them. */\n\n.jobact {\n  width: 100%;\n  padding: 0 24px 24px;\n}\n\n/* 16px between entries: Figma's Log frames sit at 0 / 125 / 250 / 371 with\n   heights of 109 and 105. */\n.jobact-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.jobact-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n.jobact-entry.is-automated .jobact-head {\n  gap: 8px;\n}\n\n/* A person's 28px photo or initials (the dashboard Avatar is 40px). */\n.jobact-avatar .dashv2-avatar {\n  width: 28px;\n  height: 28px;\n  font-size: 11px;\n}\n\n/* The GravyWork mark at the design's 24px, the artwork scaled with it. Two\n   classes so it wins over `.dashv2-panel-actbot` whatever order the two\n   stylesheets load in. */\n.jobact .jobact-mark {\n  width: 24px;\n  height: 24px;\n  background-size: 18px 16.5px;\n}\n\n.jobact-who {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n.jobact-entry.is-automated .jobact-who {\n  gap: 0;\n}\n\n.jobact-name {\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--black);\n}\n.jobact-name b {\n  font-weight: 700;\n}\n.jobact-role {\n  font-weight: 400;\n}\n\n.jobact-when {\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--subtext);\n}\n\n/* The sentence, indented under the name: 36px left, 12px right and vertical. */\n.jobact-body {\n  padding: 12px 12px 12px 36px;\n}\n.jobact-card {\n  padding: 12px;\n  border: 1px solid var(--stroke-gray);\n  border-radius: 12px;\n  background: #fafafa;\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--black);\n}\n/* The shared sentence is a flex item in the panel row; here it is just text. */\n.jobact-card .dashv2-panel-acttext {\n  display: inline;\n}\n\n.jobact-occurrence,\n.jobact-state {\n  margin: 0 0 16px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--subtext);\n}\n\n.jobact-retry,\n.jobact-more {\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  font-weight: 600;\n  color: var(--text-green);\n  cursor: pointer;\n}\n.jobact-more {\n  margin: 16px 0 0 36px;\n}\n.jobact-retry:hover,\n.jobact-more:hover {\n  text-decoration: underline;\n}\n.jobact-more:disabled {\n  color: var(--subtext);\n  cursor: default;\n  text-decoration: none;\n}\n\n/* The sort toggle, at the right end of the tab strip as Figma places it. */\n.jobact-sort {\n  position: absolute;\n  top: 50%;\n  right: 24px;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: none;\n  color: #1c1c1c;\n  cursor: pointer;\n}\n.jobact-sort:hover {\n  background: #f3f3f3;\n}\n.jobact-sort:focus-visible {\n  outline: 2px solid #2f6fed;\n  outline-offset: 2px;\n}\n.jobact-sort svg {\n  width: 24px;\n  height: 24px;\n}\n\n@media (max-width: 600px) {\n  .jobact {\n    padding: 0 0 24px;\n  }\n  .jobact-body {\n    padding-left: 12px;\n    padding-right: 0;\n  }\n  .jobact-sort {\n    right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
